module.exports = __webpack_public_path__ + "static/media/invites.1442636f.jpg";